// removed by extract-text-webpack-plugin
module.exports = {"this---empty":"bag1g2z5d2xavaukgyc1hk2sv2jg7e7eqdnf3kdseyscdgeazmmajr3kcgvzjf1sjcdcy9e342785mz4u1wm3gdc29xnr6xt3r5vsx-DateTime-module-this---empty"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DateTime/DateTime.module.scss
// module id = 560
// module chunks = 0